const LS_USER_KEY = 'user';
const LS_STUDY_GROUP_KEY = 'study-group';
const LS_TOKEN_KEY = 'token';

export {
    LS_USER_KEY,
    LS_STUDY_GROUP_KEY,
    LS_TOKEN_KEY,
};
